import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints } from "../../../utils/app-constants";

/**
 * The search for the addresses waiting on a review
 */
export class AddressReviewSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(10000);
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_ADDRESSES_PENDING_APPROVAL_LIST;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;

    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('Name', 'name', false),
            new ListColumn('Dealer', 'customerId', false),
            new ListColumn('Address', 'address', false),
            new ListColumn('City', 'city', false),
            new ListColumn('State', 'state', false),
            new ListColumn('Country', 'country', false),
            new ListColumn('Jobsite', 'isJobSite', false),
            new ListColumn('Orders', 'orders', false),
            new ListColumn('Reviewed', 'reviewUser', false)
        ];

        // Create our Filter Groups
        this.filters.push(
            this.buildDealer(),
            this.buildOrder()
        );

    }

    // #region Group Builders

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealerId');
        const opt1 = new FilterBarInputOpt('Dealer', '');

        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildOrder() {
        const byOrderId = new FilterGroup('Order ID', 'text', 'orderId');
        const opt1 = new FilterBarInputOpt('Order ID', '');

        byOrderId.opts = [opt1];

        return byOrderId;
    }

    // #endregion

}
